import { useMediaQuery, useTheme } from '@mui/material';
import { Fragment, ReactNode, useEffect, useState } from 'react';
import SmallScreenNotice from 'src/components/common/SmallScreenNotice';

const DesktopOnlyWrapper = ({ children }: { children: ReactNode }) => {
  const theme = useTheme();
  const [shouldCheckSmallScreen, setShouldCheckSmallScreen] = useState(true);
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('lg'));

  useEffect(() => {
    // Listen Print Event from browser
    const mql = window.matchMedia('print');
    mql.addEventListener('change', () => handleMatchChange(mql));
    return () => {
      mql.removeEventListener('change', () => handleMatchChange(mql));
    };
  }, []);

  const handleMatchChange = (mql: ExpectedAny) => {
    setShouldCheckSmallScreen(false);
    if (mql.matches) {
      // Before Print
    } else {
      // After print
    }
  };

  if (isSmallScreen && shouldCheckSmallScreen) {
    return <SmallScreenNotice />;
  }

  return <Fragment>{children}</Fragment>;
};

export default DesktopOnlyWrapper;
